import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ReplyBubbleIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "17",
    rx: "2"
  }), /*#__PURE__*/_jsx("path", {
    d: "M5,18v3.5a.5.5,0,0,0,.85.35L9,18Z"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "9.85 13.21 6.62 10 9.82 6.8",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7,10h7a2.92,2.92,0,0,1,3,3",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: "2"
  })]
}), 'ReplyBubbleIcon');